<template>
  <common-template>
        <div class="list">
          <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="table-list inner">
          <h2 class="title">{{ $t("検索結果") }}</h2>
          <div class="content">
            <table class="table table-bordered">
              <thead class="thead">
                <tr>
                  <th width="100" scope="col">{{ $t("種別") }}</th>
                  <th width="200" scope="col">{{ $t("ファイル名") }}</th>
                  <th width="200" scope="col">{{ $t("受付時間") }}</th>
                  <th width="130" scope="col">{{ $t("ユーザー名") }}</th>
                  <th width="100" scope="col">{{ $t("ステータス") }}</th>
                  <th width="300" scope="col">{{ $t("失敗理由") }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <template v-if="!load && mixinGetItems.length">
                  <tr v-for="(item, index) in mixinGetItems" :key="index">
                    <td>
                      <template v-if="item.type === 'product'">
                        {{ $t('製品') }}
                      </template>
                      <template v-else-if="item.type === 'productProcess'">
                        {{ $t('標準工程') }}
                      </template>
                      <template v-else-if="item.type === 'structure'">
                        {{ $t('構成部品表') }}
                      </template>
                      <template v-else-if="item.type === 'order'">
                        {{ $t('受注') }}
                      </template>
                      <template v-else-if="item.type === 'ship'">
                        {{ $t('出庫計画') }}
                      </template>
                      <template v-else-if="item.type === 'ship-deliver'">
                        {{ $t('出庫実績') }}
                      </template>
                      <template v-else-if="item.type === 'supply-deliver'">
                        {{ $t('入庫実績') }}
                      </template>
                      <template v-else-if="item.type === 'lot'">
                        {{ $t('棚卸') }}
                      </template>
                      <template v-else-if="item.type === 'project'">
                        {{ $t('案件') }}
                      </template>
                      <template v-else-if="item.type === 'inventory'">
                        {{ $t('在庫') }}
                      </template>
                      <template v-else-if="item.type === 'supply-extra'">
                        {{ $t('入庫計画') }}
                      </template>
                      <template v-else-if="item.type === 'partners'">
                        {{ $t('取引先') }}
                      </template>
                    </td>
                    <td>{{ item.fileName }}</td>
                    <td>{{ mixinTimestampToFormat(item.datetime,'YYYY/MM/DD HH:mm') }}</td>
                    <td>{{ mixinIdKeyDisplay('users',item.userId,'name') }}</td>
                    <td>
                      <template v-if="item.status === 'success'">
                        {{ $t('完了') }}
                      </template>
                      <template v-else-if="item.status === 'failed'">
                        {{ $t('失敗') }}
                      </template>
                      <template v-else-if="item.status === 'skip'">
                        {{ $t('一部失敗') }}
                      </template>
                      <template v-else-if="item.status === 'inprogress'">
                        {{ $t('処理中') }}
                      </template>
                    </td>
                    <td><span style="white-space: pre-wrap;">{{ item.comment }}</span></td>
                  </tr>
                </template>
                <template v-else-if="!load && !mixinGetItems.length">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t("ノーデータメッセージ") }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="load">
                  <tr>
                    <td colspan="12">
                      <div class="d-flex justify-content-center m-5" v-if="load">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
          <paginate
           :page-count="mixinGetPageCount"
           :force-page="mixinGetForcePage"
           :page-range="3"
           :margin-pages="1"
           :click-handler="mixinClickCallback"
           :prev-text="'«'"
           :next-text="'»'"
           :container-class="'pagination justify-content-end'"
           :page-class="'page-item'"
           :page-link-class="'page-link'"
           :prev-class="'page-item'"
           :prev-link-class="'page-link'"
           :next-class="'page-item'"
           :next-link-class="'page-link'"
           ref="page"
          ></paginate>
      </div>
  </common-template>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      list: [],
      master: {},
      users: [],
      load: false,
      pageTitle: 'データ一覧',
    }
  },
  components: {
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.getUsers()
    await this.search()
  },
  methods: {
    async getUsers() {
      try {
        this.users = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/users`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.users = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async search() {
      this.load = true
      try {
        this.list = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/imports`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.list = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
